import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4bab4a3c"
var script = {}
import style0 from "@/assets/css/element-m.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/app.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_css-loader@6.11.0_webpack@5.99.9__ejs@3.1.1_a2a63bc0f9ddcf39751e5b2da33f84ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports